<a *ngIf="backConfig$ | async as config" rds-link standalone size="s" type="secondary" (click)="leavePageWarning && changesMade ? openLeavePageDialog() : back()">
  <rds-icon namespace="filled" icon="chevron_left"></rds-icon>
  Back to {{config.label}}
</a>
